import axios from "axios";
import config from "../../config/config";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

//https://endpoint.purpletv.app/purple_player_duplex/v2/samsung.json

const url = `${config.URL}/purple_player_duplex/v2/samsung.json`;

const EndpointApi = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        "https://endpoint.purpletv.app/purple_player_duplex/rb/v2.json"
      );
      dispatch({
        type: "END_POINTS",
        payload: response,
      });
    } catch (error) {
      console.error("Endpoint API Error: ", error);
      try {
        const response = await axios.get(
          "https://cors.b-cdn.net/https://endpoint.purpletv.app/purple_player_duplex/rb/v2.json"
        );
        dispatch({
          type: "END_POINTS",
          payload: response,
        });
      } catch (scriptError) {
        console.error("Fallback Endpoint API Error: ", scriptError);
      }

    }
  };
};

export default EndpointApi;
